export function isInvertedIsoDateRange(
  dateFrom: string | null | undefined,
  dateTo: string | null | undefined
): boolean {
  if (!dateFrom || !dateTo) return false;

  const from = Date.parse(dateFrom);
  const to = Date.parse(dateTo);

  if (Number.isNaN(from) || Number.isNaN(to)) return false;

  return from > to;
}
